import styled from 'styled-components';

import { CARD_WIDTH } from '../locked-offers-card/locked-offers-card.styled';

import { SINGLE_PADDING } from './constants';

export const SingleWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: ${SINGLE_PADDING};
  & > div {
    width: 100%;
  }
  ${Styles.desktop`
    padding: 20px 1rem;
    & > div {
      width: ${CARD_WIDTH};
    }
  `}
`;

export const Wrapper = styled.div`
  ${Styles.desktop`
    padding: 0;
  `};
`;
